/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCommentDto } from '../../models/contents-request-comment-dto';

export interface ContentsRequestCommentControllerFindByContentsRequestId$Params {
  id: string;
}

export function contentsRequestCommentControllerFindByContentsRequestId(http: HttpClient, rootUrl: string, params: ContentsRequestCommentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestCommentDto>>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestCommentControllerFindByContentsRequestId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentsRequestCommentDto>>;
    })
  );
}

contentsRequestCommentControllerFindByContentsRequestId.PATH = '/api/contents-request-comment/{id}/contentsRequest';
